import { PreloaderHandlerInterface } from './webglLoadingHandler';
import { sendClientCompilationStageCompleteFact, sendClientPreloaderProgressFact } from '../../stat/factHelpers';
import { COMPATIBILITY_CHECK_FAILED_PERCENTS, PRELOADER_PERCENTS_REAL } from './preloaderPercentsLayout';
import { isGetUserFinished } from '../../general/modules/getUser';
import { UserSession } from '../../general/modules/user/userSession';

const COMPILING_PROGRESS_FACT_CHECKPOINTS = [0.25, 0.5, 0.75, 1];
let compilingCheckpoints = COMPILING_PROGRESS_FACT_CHECKPOINTS;


export class StatWebglLoadingHandler implements PreloaderHandlerInterface {
    loadingStartTimer: Date;
    startTs: number;

    public static async sendNewUserPrecompileStageFact(stage: string) {
        if (await UserSession.getInstance().isNewProgress()) {
            sendClientCompilationStageCompleteFact(stage, 0, 0);
        }
    }

    public enableUnityLoaderMonitor() {
        const unityJobScheduleFunction = window.UnityLoader.Job.schedule;
        // eslint-disable-next-line
        window.UnityLoader.Job.schedule = (Module: any, id: any, dependencies: any, callback: any, parameters?: any) => {
            isGetUserFinished().then(() => {
                sendClientCompilationStageCompleteFact(`schedule${id}`, this.getMillisSinceStart(), this.getStartTs());
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let overrideCallback: (...args: any[]) => void = callback;
            try {
                overrideCallback = (...args) => {
                    try {
                        isGetUserFinished().then(() => {
                            sendClientCompilationStageCompleteFact(id, this.getMillisSinceStart(), this.getStartTs());
                        });
                    } catch (error) {
                        console.error(error);
                    }

                    callback(...args);
                };
            } catch (error) {
                console.error(error);
            }

            return unityJobScheduleFunction(Module, id, dependencies, overrideCallback, parameters);
        };
    }

    public startTimer(): void {
        this.loadingStartTimer = new Date();
    }

    public getMillisSinceStart(): number {
        return Number(new Date()) - Number(this.loadingStartTimer);
    }

    public getStartTs(): number {
        if (!this.startTs) {
            this.startTs = Math.floor(Date.now() / 1000);
        }
        return this.startTs;
    }

    public onClientLoadingProgressChanged(clientLoadingPercent: number): void {
        sendClientPreloaderProgressFact(clientLoadingPercent, this.getMillisSinceStart(), this.getStartTs());
    }

    public onCompatibilityCheckFailed(): void {
        sendClientPreloaderProgressFact(
            COMPATIBILITY_CHECK_FAILED_PERCENTS,
            this.getMillisSinceStart(),
            this.getStartTs()
        );
    }

    public onCompileProgressChange(compileProgressShare: number): void {
        if (compilingCheckpoints.length) {
            const passedCheckpoints = compilingCheckpoints.filter((checkpointPercents: number) => {
                return checkpointPercents <= compileProgressShare;
            });

            compilingCheckpoints = compilingCheckpoints.filter((checkpointPercents: number) => {
                return !passedCheckpoints.includes(checkpointPercents);
            });

            passedCheckpoints.forEach((checkpointPercents: number) => {
                sendClientPreloaderProgressFact(
                    checkpointPercents * PRELOADER_PERCENTS_REAL.compilingEndPercent,
                    this.getMillisSinceStart(),
                    this.getStartTs()
                );
            });
        }
    }

    public onPreStart(_initialPercents: number): void {
        sendClientPreloaderProgressFact(
            PRELOADER_PERCENTS_REAL.initialPercent,
            this.getMillisSinceStart(),
            this.getStartTs()
        );
    }
}
